export default "/images/0e8078aeea15948e5d8ced2bc70627f8.png";